import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = BACKEND_URL ? `${BACKEND_URL}/api` : "";
export const TOKEN_KEY = "lbs_owner_token";

export const api = axios.create({ baseURL: API_BASE });
api.interceptors.request.use((config) => {
  const vipPath = typeof config.url === "string" && config.url.startsWith("/vip");
  const token = vipPath ? localStorage.getItem("lbs_vip_token") : localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const assetUrl = (path) => (BACKEND_URL && path ? `${BACKEND_URL}${path}` : "");

export function errorText(err, fallback = "Something went wrong. Please try again.") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg).filter(Boolean).join(" ") || fallback;
  return fallback;
}
